module.exports = __webpack_public_path__ + "img/GanglionCyst.dd7005f8.svg";